import { Box, List } from '@mui/material';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';

interface ItemProps {
  item: React.JSX.Element;
}

interface MenuProps {
  items: React.JSX.Element[];
}

export const SortableLinkedListItem = SortableElement(({ item }: ItemProps) => (
  <Box
    sx={{
      zIndex: 20000,
    }}
  >
    {item}
  </Box>
));

export const SortableSubmenu = SortableContainer(({ items }: MenuProps) => (
  <List disablePadding style={{ width: '100%' }}>
    {items.map((item, index: number) => (
      <SortableLinkedListItem key={index} index={index} item={item} />
    ))}
  </List>
));
